module.exports = __webpack_public_path__ + "imgs/study-owl.3ec6a5effa841a9844be07ff4f29cbc7.svg";